import { createContext } from "react"

const DocumentContext = createContext();

export default DocumentContext;